import 'react-multi-carousel/lib/styles.css';

import React from 'react'
import moment from 'moment';
import 'moment/locale/pt-br';
import Carousel from 'react-multi-carousel';

import TinyChip from '../chips/tiny-chip';
import { formatToBRL } from '../../helpers/formatter';

moment.locale('pt-br');

const responsive = {
    superLargeDesktop: {
        breakpoint: { max: 4000, min: 3000 },
        items: 2,
        partialVisibilityGutter: 40
    },
    desktop: {
        breakpoint: { max: 3000, min: 1024 },
        items: 2,
        partialVisibilityGutter: 40
    },
    tablet: {
        breakpoint: { max: 1024, min: 768 },
        items: 2,
        partialVisibilityGutter: 30
    },
    mobile: {
        breakpoint: { max: 768, min: 0 },
        items: 1.5,
        partialVisibilityGutter: 20
    }
};

export default function WinnersCarrosel({ generalWinners }) {
    if (generalWinners == null || generalWinners?.length === 0) {
        return (
            <div />
        )
    }

    return (
        <div style={{ width: "100%" }}>
            <Carousel
                additionalTransfrom={0}
                autoPlay
                autoPlaySpeed={3000}
                arrows={false}
                centerMode={false}
                customTransition="all 1.5s ease-in-out"
                draggable
                focusOnSelect={false}
                infinite
                keyBoardControl
                minimumTouchDrag={80}
                pauseOnHover
                renderArrowsWhenDisabled={false}
                renderButtonGroupOutside={false}
                renderDotsOutside={false}
                responsive={responsive}
                rewind={false}
                rewindWithAnimation={true}
                rtl={false}
                shouldResetAutoplay
                swipeable={true}
                slidesToSlide={1}
                transitionDuration={1500}
                showDots={false}
                style={{ width: "100%" }}
            >
                {
                    generalWinners.map((item, index) => (
                        <WinnerItem key={index} clientName={item.client_name} value={item.award} updatedAt={item.updated_at} />
                    ))
                }

            </Carousel>
        </div>
    )
}
const WinnerItem = ({
    clientName,
    value,
    updatedAt
}) => {
    const [isMobile, setIsMobile] = React.useState(false);

    React.useEffect(() => {
        if (typeof window == "undefined") {
            return
        }

        const checkMobile = () => {
            setIsMobile(window.innerWidth <= 768);
        };
        checkMobile();
        window.addEventListener('resize', checkMobile);
        return () => window.removeEventListener('resize', checkMobile);
    }, []);

    return (
        <div style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            gap: isMobile ? "8px" : "12px",
            backgroundColor: "black",
            margin: isMobile ? "5px" : "10px",
            padding: isMobile ? "8px 10px" : "12px 16px",
            borderRadius: isMobile ? 10 : 12,
            boxShadow: "0 2px 8px rgba(0, 0, 0, 0.2)",
            minHeight: isMobile ? "60px" : "auto"
        }}>
            {/* Ícone circular à esquerda */}
            <div style={{
                width: isMobile ? 35 : 40,
                height: isMobile ? 35 : 40,
                borderRadius: "50%",
                border: "2px solid #1d5f3a",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: "#1a1d23",
                flexShrink: 0
            }}>
                <span style={{ fontSize: isMobile ? 16 : 20 }}>💵</span>
            </div>

            {/* Nome e timestamp */}
            <div style={{ flex: 1, minWidth: 0, overflow: "hidden" }}>
                <div style={{
                    fontSize: isMobile ? 12 : 14,
                    color: "white",
                    fontWeight: 500,
                    marginBottom: 2,
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap"
                }}>
                    {clientName}
                </div>
                <div style={{
                    fontSize: isMobile ? 10 : 12,
                    color: "#9ca3af",
                    whiteSpace: "nowrap"
                }}>
                    {moment(updatedAt).fromNow()}
                </div>
            </div>

            {/* Valor e método de pagamento */}
            <div style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-end",
                gap: isMobile ? 2 : 4,
                flexShrink: 0
            }}>
                <div style={{
                    color: "#2ecc71",
                    fontSize: isMobile ? 12 : 14,
                    fontWeight: "bold",
                    whiteSpace: "nowrap"
                }}>
                    { value.includes("R$") ? value : formatToBRL(value)}
                </div>
                <TinyChip
                    label={"PIX"}
                    style={{
                        backgroundColor: "#2ecc71",
                        fontSize: isMobile ? 8 : 10,
                        padding: isMobile ? "1px 6px" : "2px 8px",
                        borderRadius: 12
                    }}
                />
            </div>
        </div>
    );
}
